const ws = {
  methods: {
    wsInit (focus) {
      if (typeof (WebSocket) === 'undefined') {
        alert('您的浏览器不支持socket');
      } else if (this.socket && !focus) {
        console.log('socket已初始化');
      } else {
        // 实例化socket
        this.socket = new WebSocket('wss://' + location.host + '/ws');
        // 监听socket连接
        this.socket.onopen = this.wsOpen;
        // 监听socket错误信息
        this.socket.onerror = this.wsError;
        // 监听socket消息
        this.socket.onmessage = this.wsGetMessage;
      }
    },
    wsOpen () {
      console.log('socket连接成功');
    },
    wsError () {
      console.log('连接错误');
    },
    wsGetMessage (msg) {
      const data = JSON.parse(msg.data);
      if (data.type === 14) {
        const message = JSON.parse(data.message);
        if (this.handleWsMsg) {
          this.handleWsMsg(message);
        } else {
          console.log('ws data:', message);
        }
      }
    },
    wsSend (params) {
      this.socket.send(params);
    },
    wsClose () {
      console.log('socket已经关闭');
    },
  },
  destroyed () {
    // 销毁监听
    this.socket.onclose = this.destroyed;
  },
  created () {
    this.wsInit();
  },
};

export default ws;
